import { Translation } from "@maine-cat/i18n/en"

export const zh: DeepPartial<Translation> = {}
